import cn from 'classnames';
import connect from 'components/Shared/connect';
import {
  getSeoBlock,
  getDescription,
  getPageNumber,
  getBrandContent
} from 'views/ProductlistPage/selectors';
import { ReactComponent } from 'models/ReactComponent';
import Markdown from 'components/Shared/Markdown';
import styles from './SEOBlock.scss';
import { NO_ELEMENT } from 'utils';
import { ProductlistPageBrandContent } from 'models/ProductlistPageBrandContent';

interface SEOBlockProps {
  pageNumber: number;
  description: string;
  seoBlock?: ReactComponent;
  isBrandPage?: boolean;
}

const USE_COLUMNS_BREAKPOINT = 2000;

const getSeoBlockLength = (seoBlock?: ReactComponent) =>
  seoBlock && seoBlock.content ? seoBlock.content.length : 0;

const _SEOBlock = ({ description = '', seoBlock, pageNumber, isBrandPage }: SEOBlockProps) => {
  if (pageNumber > 1) {
    return NO_ELEMENT;
  }

  const totalLength = description.length + getSeoBlockLength(seoBlock);
  const useColumns = totalLength > USE_COLUMNS_BREAKPOINT;

  return (
    <div
      className={cn(styles.seoBlock, {
        [styles.columns]: useColumns
      })}
    >
      <div className={styles.content}>
        {!isBrandPage && description && <p>{description}</p>}
        {seoBlock && <Markdown {...seoBlock} />}
      </div>
    </div>
  );
};

interface MergedProps extends SEOBlockProps {
  brandPage?: ProductlistPageBrandContent;
}

export const SEOBlock = connect<MergedProps, Record<string, never>, SEOBlockProps>(
  ({ currentPage }) => ({
    description: getDescription(currentPage),
    seoBlock: getSeoBlock(currentPage),
    pageNumber: getPageNumber(currentPage),
    brandPage: getBrandContent(currentPage)
  }),
  {},
  ({ brandPage, ...state }) => ({
    ...state,
    isBrandPage: brandPage !== undefined
  })
)(_SEOBlock);
